/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChartOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import { Dashboard } from './dashboard';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { FaSuitcaseMedical } from 'react-icons/fa6';
import { FaHandHoldingMedical } from 'react-icons/fa';
import { TbHealthRecognition } from 'react-icons/tb';

/**
 * Export `SkinMedicalInstruments` component.
 */

export function SkinMedicalInstruments(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: 'overview',
          pathname: appRoutes.dashboard.medical.base,
          icon: <PieChartOutlined />,
          label: translate('medicalInstruments.menu.overview')
        },
        {
          key: 'drugs',
          pathname: appRoutes.dashboard.medical.drugs,
          icon: <FaSuitcaseMedical />,
          label: translate('medicalInstruments.menu.drugs')
        },
        {
          key: 'missingDrugs',
          pathname: appRoutes.dashboard.medical.missingDrugs,
          icon: <FaHandHoldingMedical />,
          label: translate('medicalInstruments.menu.missingDrugs')
        },
        {
          key: 'ccisCodes',
          pathname: appRoutes.dashboard.medical.ccisCodes,
          icon: <TbHealthRecognition />,
          label: translate('medicalInstruments.menu.ccisCodes')
        },
        {
          key: 'ccisDrugs',
          pathname: appRoutes.dashboard.medical.ccisDrugs,
          icon: <TbHealthRecognition />,
          label: translate('medicalInstruments.menu.ccisDrugs')
        },
        {
          key: 'ccis',
          pathname: appRoutes.dashboard.medical.ccis,
          icon: <TbHealthRecognition />,
          label: translate('medicalInstruments.menu.ccis')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
